import React, { useState } from "react";
import { Icon, Table } from "semantic-ui-react";
import { addSubscriptionToMember } from "../../actions/videoInput";
import { useAppDispatch } from "../../hooks/redux";
import { memberSubscription } from "../../types/member";
import SubscriptionsOptionSelect from "./SubscriptionsOptionSelect";

interface  PlayerDetailsSubscriptionsProps{
  heibaSubscriptions: memberSubscription[] | undefined
  memberId: number
}

export default function PlayerDetailsSubscriptions(props:PlayerDetailsSubscriptionsProps) {
  const [customerId, set_CustomerId] = useState("Selecteer een klant");
  const dispatch = useAppDispatch()
  if (!props.heibaSubscriptions) return null;
  if (!props.memberId) return null;
  
  
  const generalCell = (header:string, info:string) => {
    return (
      <Table.Row key={header}>
        <Table.Cell style={{ padding: ".28571429em" ,minWidth: "120px"}}>{header}</Table.Cell>
        <Table.Cell style={{ padding: ".28571429em", minWidth: "150px" }}>{info}</Table.Cell>
      </Table.Row>
    );
  };
  const addAccountToMember = () => {
    if(typeof customerId != 'string'){
      // alert('Voeg eerst een account toe')
      dispatch(addSubscriptionToMember(props?.memberId, Number(customerId)));
    }
  }

  const addButton = () => {
    return generalCell(
      //@ts-ignore
      dropdown(),
      <div style={{ width: "60px", textAlign: "center" }}>
        <Icon name="plus circle" onClick={addAccountToMember} style={{cursor: 'pointer'}} />
      </div>
    );
  };
  const dropdown = () => {
    return (
      <div>
        <SubscriptionsOptionSelect set_subscription={set_CustomerId}/>
      </div>
    );
  };

  return (
    <div>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{ padding: ".28571429em" }}>Abbonnement Type</Table.HeaderCell>
            <Table.HeaderCell style={{ padding: ".28571429em", minWidth: "150px"}}>id</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {props?.heibaSubscriptions?.map(mm =>  generalCell(`${mm?.heibaSubscription?.name}`, `${mm?.id}`))}
          {addButton()}
        </Table.Body>
      </Table>
    </div>
  );
}
